/**
 * Created by zzy on 2019/8/5.
 */
import VehicleViolatoinDetection from './VehicleViolatoinDetection.vue'
export default VehicleViolatoinDetection



// WEBPACK FOOTER //
// ./src/views/monitoring/vehicleViolatoinDetection/index.js